import React, { FC, useEffect, useState } from 'react';
import { toAbsoluteUrl } from '../../utils';
import { CustomerForm } from '../../components/customer/CustomerForm';
import { CustomerThanksPage } from '../../components/customer/CustomerThanksPage';
import { IModalWindow, ModalWindow } from '../../components/modal/ModalWindow';
import { useTranslation } from 'react-i18next';
import { SITE_KEY } from '../login/Login';
import { LinkComponent } from '../../components/LinkComponent';
import { LoginLayout } from '../../components/login/LoginLayout';

export const CustomerPage: FC = () => {
	const { t } = useTranslation();
	const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
	const [description, setDescription] = useState<string>('');
	const [isGetHelpModalOpen, setGetHelpModalState] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	useEffect(() => {
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
		document.body.appendChild(script);
	}, []);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const confirmModalContent = (
		<div className="w-100">
			<div className="text-center fw-bolder fs-2 mt-10">
				{t('CONFIRM_APP.MODAl_CONFIRM_TITLE')}
			</div>
			<div className="fs-6 d-flex flex-column align-items-center mt-5">
				<div>{t('CONFIRM_APP.MODAl_CONFIRM_TEXT')}</div>
				<div>{t('CONFIRM_APP.MODAl_CONFIRM_SUB_TEXT')}</div>
			</div>
		</div>
	);

	const getHelpModalContent = (
		<div className="w-100 d-flex flex-column align-items-center px-7 py-5">
			<div className="fs-6 my-5">
				Please describe the issue.
			</div>
			<div className="col-12">
				<label className="form-label col-12">
					Description
					<textarea
						maxLength={250}
						className="form-control form-control-sm form-control-solid resize-none mt-1 h-100px"
						placeholder="Write description here"
						value={description}
						onChange={(e): void => setDescription(e.target.value)}
					/>
				</label>
			</div>
		</div>
	);

	const handleConfirmModal = (): void => {

		setGetHelpModalState(false);
		setModalState({
			isOpen: true,
			modalTitle: 'Get Help',
			contentClassName: 'd-block',
			minHeight: 150,
			content: confirmModalContent,
		});
	};

	return (
		<>
			<LoginLayout>
				<div className="form-container">
					<img
						className="w-200px"
						src={toAbsoluteUrl('/media/flex-logo-small.svg')}
						alt="logo"
					/>
					<div className="mt-10 fs-2 fw-bolder">Insert your order id below</div>
					<div className="mt-2 fs-5 text-muted">
						Having issues?{' '}
						{/*<span*/}
						{/*	className="text-primary cursor-pointer"*/}
						{/*	onClick={(): void => setGetHelpModalState(true)}*/}
						{/*>*/}
						{/*	{t('CONFIRM_APP.MODAL_TITLE')}*/}
						{/*</span>*/}
						<LinkComponent text={t('CONFIRM_APP.MODAL_TITLE')} link='mailto:support@flex-charge.com'/>
					</div>
					{
						isSubmitted
							? <CustomerThanksPage/>
							: <CustomerForm setIsSubmitted={setIsSubmitted}/>
					}
				</div>
			</LoginLayout>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

			<ModalWindow
				isOpen={isGetHelpModalOpen}
				onClose={(): void => setGetHelpModalState(false)}
				onConfirm={handleConfirmModal}
				onCancel={(): void => setGetHelpModalState(false)}
				confirmDisabled={Boolean(!description)}
				modalTitle={t('CONFIRM_APP.MODAL_TITLE')}
				content={getHelpModalContent}
				confirmButtonText={'Send'}
			/>
		</>
	);
};
